import {
  getPmitList,
  getTaskListTemplate,
  importTaskLists,
  lockAllPmit,
  unlockAllPmit,
} from "@ckweb/ckfetch/connectables/taskListManagement";
import { getSkillList } from "@ckweb/ckfetch/connectables/employeeManagement";

const FETCH_ID = "TaskList";

export const useGetTaskListTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, getTaskListTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetTaskList = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getPmitList, {
    fallback: (data) => data?.tasks ?? [],
  });

export const useSubmitTaskList = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importTaskLists, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });

export const useGetSkillList = () =>
  useSafeLocalFetch(`fetchSkillList`, getSkillList, {
    fallback: [],
  });

// Task Locking
export const useLockTasksForImport = () =>
  useSafeLocalFetch(`lockAllPmit`, lockAllPmit, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });

export const useUnlockTasksForImport = () =>
  useSafeLocalFetch(`unlockAllPmit`, unlockAllPmit, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
